// Charidy's public campaign API (no auth, CORS-open). The only file that
// knows about Charidy — a future provider (e.g. Raisethon) is a new module
// with the same two-function shape.
import axios from "axios";

const CHARIDY_API = "https://api.charidy.com/api/v1";

export const fetchCharidyCampaign = async (shortlink) => {
  const url =
    `${CHARIDY_API}/initial?response_v=2` +
    `&campaign_shortlink=${encodeURIComponent(shortlink)}` +
    `&extend[]=campaign_stats&page=home`;
  const response = await axios.get(url);
  const campaign = response.data?.data?.attributes?.campaign;
  const attrs = campaign?.attributes;
  if (!attrs) {
    throw new Error("Campaign not found");
  }
  return {
    campaignId: attrs.campaign_id,
    title: attrs.title,
    goal: attrs.rounds?.[0]?.goal ?? null,
    totalRaised: campaign?.relationships?.campaign_stats?.data?.total ?? null,
    startDate: attrs.start_date,
    endDate: attrs.end_date,
  };
};

export const fetchCharidyDonations = async (campaignId, limit = 50) => {
  const response = await axios.get(
    `${CHARIDY_API}/campaign/${campaignId}/donations?limit=${limit}&sortBy=-time`
  );
  const donations = (response.data?.data ?? [])
    .filter((d) => d?.attributes?.name && d.attributes.name.trim())
    .map((d) => ({
      id: d.id,
      name: d.attributes.name.trim(),
      amount: d.attributes.total,
      currencySign: d.attributes.currency_sign || "$",
      dedication: d.attributes.dedication || "",
      hideAmount: !!d.attributes.hide_donation_amount,
    }));
  const donorCount =
    parseInt(response.headers?.["x-total-donations"], 10) || donations.length;
  return { donations, donorCount };
};
